import { Category } from '../constants';
import { Protocol } from './index';

const defi: Protocol[] = [
    {
        name: 'Dopin Protocol',
        url: 'https://linktr.ee/dopinprotocol',
        logoPath: '/logos/Logo_Only.svg',
        category: Category.Defi,
        twitterUrl: 'https://x.com/Dopinprotocol',
      }
];

export { defi };
